import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { CartLimitDto } from '@lentau/cart/limit/store/dto/cart-limit.dto';
import { checkEmptyFields } from '../utils';
import { OrderModel } from '@lentau/order/shared/models/interfaces';

export function orderUpdateItemsHandler(data: { OrderList: OrderModel }): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.OrderList?.Id,
        errorName: 'IdIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function orderUpdateGetLimitHandler(data: CartLimitDto): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.startBuildTime,
        errorName: 'startBuildTimeIsEmpty',
      },
      {
        fieldToCheck: data?.orderWeight,
        errorName: 'orderWeightIsEmpty',
      },
      {
        fieldToCheck: data?.maxOrderWeight,
        errorName: 'maxOrderWeightIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}
